import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-van-nuys')!;

const VanNuysPage = () => <CityLandingPage data={data} />;

export default VanNuysPage;
